var _path, _g, _path2, _g2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitepaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14219 0.832031C2.14181 0.832031 2.14139 0.832031 2.14101 0.832031C2.0086 0.832031 1.88406 0.881109 1.79002 0.970302C1.69495 1.06048 1.64258 1.18055 1.64258 1.30838V8.45117C1.64258 8.7131 1.86757 8.92671 2.14417 8.92738C3.31026 8.93003 5.26393 9.16112 6.6117 10.5022V3.02706C6.6117 2.93827 6.58784 2.85486 6.54283 2.78584C5.43665 1.09199 3.31092 0.834631 2.14219 0.832031Z",
    fill: "url(#paint0_linear_2373_22541)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2373_22541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.14219 0C2.14181 0 2.14139 0 2.14101 0C2.0086 0 1.88406 0.0490782 1.79002 0.138271C1.69495 0.228449 1.64258 0.348523 1.64258 0.47635V7.61914C1.64258 7.88107 1.86757 8.09468 2.14417 8.09535C3.31026 8.098 5.26393 8.32909 6.6117 9.67016V2.19503C6.6117 2.10624 6.58784 2.02283 6.54283 1.95381C5.43665 0.259958 3.31092 0.00259958 2.14219 0Z",
    fill: "white",
    fillOpacity: 0.17
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3577 8.45121V1.30838C12.3577 1.18055 12.3054 1.06048 12.2103 0.970302C12.1163 0.881109 11.9916 0.832031 11.8594 0.832031C11.8589 0.832031 11.8585 0.832031 11.8581 0.832031C10.6894 0.834676 8.56372 1.09203 7.45749 2.78588C7.41248 2.85491 7.38867 2.93832 7.38867 3.02711V10.5022C8.73643 9.16112 10.6901 8.93003 11.8562 8.92738C12.1328 8.92671 12.3577 8.7131 12.3577 8.45121Z",
    fill: "url(#paint1_linear_2373_22541)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2373_22541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3577 7.61918V0.47635C12.3577 0.348523 12.3054 0.228449 12.2103 0.138271C12.1163 0.0490782 11.9916 0 11.8594 0C11.8589 0 11.8585 0 11.8581 0C10.6894 0.0026444 8.56372 0.260002 7.45749 1.95385C7.41248 2.02287 7.38867 2.10629 7.38867 2.19507V9.67016C8.73643 8.32909 10.6901 8.098 11.8562 8.09535C12.1328 8.09468 12.3577 7.88107 12.3577 7.61918Z",
    fill: "white",
    fillOpacity: 0.17
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4987 2.47656H13.1355V8.44846C13.1355 9.11723 12.5624 9.66256 11.858 9.66421C10.8689 9.66646 9.23802 9.85035 8.08301 10.8898C10.0806 10.4247 12.1864 10.727 13.3866 10.9871C13.5364 11.0195 13.6913 10.986 13.8113 10.895C13.931 10.8043 13.9996 10.6686 13.9996 10.523V2.95282C13.9996 2.69022 13.7749 2.47656 13.4987 2.47656Z",
    fill: "url(#paint2_linear_2373_22541)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.864129 8.44846V2.47656H0.500885C0.224753 2.47656 0 2.69022 0 2.95282V10.5228C0 10.6685 0.0686325 10.8041 0.188268 10.8949C0.308234 10.9858 0.46294 11.0195 0.613026 10.987C1.81315 10.7269 3.91903 10.4246 5.91654 10.8896C4.76157 9.85026 3.1307 9.66641 2.14161 9.66417C1.43723 9.66256 0.864129 9.11723 0.864129 8.44846Z",
    fill: "url(#paint3_linear_2373_22541)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2373_22541",
    x: -0.357422,
    y: -2,
    width: 8.96875,
    height: 13.6719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2373_22541"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2373_22541",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2373_22541",
    x: 5.38867,
    y: -2,
    width: 8.96875,
    height: 13.6719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2373_22541"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2373_22541",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2373_22541",
    x1: 4.12714,
    y1: 0.832031,
    x2: 4.12714,
    y2: 10.5022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F52F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99BFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2373_22541",
    x1: 9.87321,
    y1: 0.832031,
    x2: 9.87321,
    y2: 10.5022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F52F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99BFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2373_22541",
    x1: 11.0413,
    y1: 2.47656,
    x2: 11.0413,
    y2: 10.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F52F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99BFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2373_22541",
    x1: 2.95827,
    y1: 2.47656,
    x2: 2.95827,
    y2: 10.9991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F52F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99BFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitepaper);
export default __webpack_public_path__ + "static/media/whitepaper.7aa53f0f853ce51d2c05ff3347733107.svg";
export { ForwardRef as ReactComponent };